import { render, staticRenderFns } from "./push_detail.vue?vue&type=template&id=2d4d984d&scoped=true"
import script from "./push_detail.vue?vue&type=script&lang=js"
export * from "./push_detail.vue?vue&type=script&lang=js"
import style0 from "./push_detail.vue?vue&type=style&index=0&id=2d4d984d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d984d",
  null
  
)

export default component.exports